import AdminDashboardPage from './AdminDashboard';
import ServiceDashboardPage from './ServiceDashboard';
import {useNavigate} from "react-router-dom";

const DashboardRouter = ({ setMovePage }) => {
  const movePage = useNavigate();

  // const [userInfo, setUserInfo] = useState({
  //         userId: sessionStorage.getItem("userId"),
  //         userName: sessionStorage.getItem("userName"),
  //         groupId: sessionStorage.getItem("groupId"),
  //         role: sessionStorage.getItem("role")
  //     })
  
  if(sessionStorage.getItem('id') == '' || sessionStorage.getItem('id') == undefined){
    movePage('/login');
  } 
  // 기본 페이지로 fallback
  if (sessionStorage.getItem("role") == 'SYS_ADMIN'){
    return <AdminDashboardPage setMovePage={setMovePage} groupId={sessionStorage.getItem("groupId")} />;
  } else {
    return <ServiceDashboardPage setMovePage={setMovePage} groupId={sessionStorage.getItem("groupId")}/>;
  }
};

export default DashboardRouter;
